import React, { useState } from "react";
import { Eye, EyeOff, LockIcon } from "lucide-react";
import { Input, InputProps } from "@/components/ui/input";

interface PasswordInputProps extends Omit<InputProps, 'type'> {
  showLeftIcon?: boolean;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, showLeftIcon = true, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleMouseDown = (e: React.MouseEvent) => {
      e.preventDefault();
      setShowPassword(true);
    };

    const handleMouseUp = () => {
      setShowPassword(false);
    };

    const handleMouseLeave = () => {
      setShowPassword(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if ((e.key === 'Enter' || e.key === ' ') && !showPassword) {
        e.preventDefault();
        setShowPassword(true);
      }
    };

    const handleKeyUp = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setShowPassword(false);
      }
    };

    return (
      <div className="relative flex items-center">
        {showLeftIcon && (
          <LockIcon className="absolute left-3 text-muted-foreground h-4 w-4 z-10" />
        )}
        <Input
          type={showPassword ? "text" : "password"}
          className={`${showLeftIcon ? 'pl-10' : ''} pr-10 ${className || ''}`}
          ref={ref}
          {...props}
        />
        <button
          type="button"
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
          className="absolute right-2 p-1 rounded-sm text-muted-foreground/70 hover:text-muted-foreground hover:bg-muted/30 transition-all duration-200 focus:outline-none focus:ring-1 focus:ring-ring/50 focus:text-foreground select-none"
          aria-label={showPassword ? "Soltando irá ocultar a senha" : "Pressione e segure para mostrar senha"}
          tabIndex={0}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export { PasswordInput, type PasswordInputProps }; 